<template>
  <div class="form-container">
    <transition name="fade" mode="out-in">
      <div v-if="showLogin" key="login" class="form-wrapper">
        <h1 class="form-title">登录</h1>
        <el-form
          :model="loginForm"
          ref="loginForm"
          label-width="80px"
          @submit.native.prevent="submitLogin"
        >
          <!-- <SelectWithAdd
            style="margin-top: 15px"
            v-model="loginForm.hospital"
            label="医院"
            prop="hospital"
            :options="hospitals"
            placeholder="请选择医院"
            :rules="[
              { required: true, message: '请选择医院', trigger: 'change' },
              { min: 2, message: '长度至少为 2 个字符', trigger: 'change' },
            ]"
            @add-option="handleloginAddHospital"

            @change="handleloginAddHospital"
            @change="handleloginAddKeshi"
          /> -->

          <el-form-item
            style="margin-top: 15px"
            label="医院"
            prop="hospital"
            :rules="[
              { required: true, message: '请选择医院', trigger: 'change' },
              { min: 2, message: '长度至少为 2 个字符', trigger: 'change' },
            ]"
          >
            <el-select
              v-model="loginForm.hospital"
              placeholder="请选择医院"
              
            >
              <el-option
                v-for="hospital in hospitals"
                :key="hospital.value"
                :label="hospital.label"
                :value="hospital.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            label="科室"
            prop="keshi"
            :rules="[
              { required: true, message: '请选择科室', trigger: 'change' },
              { min: 2, message: '长度至少为 2 个字符', trigger: 'change' },
            ]"
          >
            <el-select
              v-model="loginForm.keshi"
              placeholder="请选择科室"
              
            >
              <el-option
                v-for="keshi in keshis"
                :key="keshi.value"
                :label="keshi.label"
                :value="keshi.value"
              />
            </el-select>
          </el-form-item>
          <!-- 自定义验证规则 -->
          <!-- <SelectWithAdd
            v-model="loginForm.keshi"
            label="科室"
            prop="keshi"
            :options="keshis"
            placeholder="请选择科室"
            :rules="[
              { required: true, message: '请选择科室', trigger: 'change' },
              { min: 2, message: '长度至少为 2 个字符', trigger: 'change' },
            ]"
            @add-option="handleloginAddKeshi"
          /> -->

          <el-form-item
            label="角色"
            prop="role"
            :rules="[
              { required: true, message: '请选择角色', trigger: 'blur' },
            ]"
          >
            <el-select v-model="loginForm.role" placeholder="请选择角色">
              <el-option label="接诊" value="接诊医生"></el-option>
              <el-option label="转诊" value="转诊医生"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            style="margin-top: 15px"
            label="用户名"
            prop="name"
            :rules="[
              { required: true, message: '请输入用户名', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="loginForm.name"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="password"
            :rules="[
              { required: true, message: '请输入密码', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              show-password
            />
          </el-form-item>

          <el-form-item>
            <div class="flex justify-between w-full">
              <el-button type="primary" @click="submitLogin">登录</el-button>
              <el-button type="primary" @click="toggleForm">去注册</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div v-else key="register" class="form-wrapper">
        <h1 class="form-title">用户注册</h1>
        <el-form
          :model="registerForm"
          ref="registerForm"
          label-width="80px"
          @submit.native.prevent="submitRegister"
        >
          <!-- 基础用法（使用默认验证规则） -->
          <SelectWithAdd
            style="margin-top: 15px"
            v-model="registerForm.hospital"
            label="医院"
            prop="hospital"
            :options="hospitals"
            placeholder="请选择医院"
            :rules="[
              { required: true, message: '请选择医院', trigger: 'change' },
              { min: 2, message: '长度至少为 2 个字符', trigger: 'change' },
            ]"
            @add-option="handleAddHospital"
          />

          <!-- 自定义验证规则 -->
          <SelectWithAdd
            v-model="registerForm.keshi"
            label="科室"
            prop="keshi"
            :options="keshis"
            placeholder="请选择科室"
            :rules="[
              { required: true, message: '请选择科室', trigger: 'change' },
              { min: 2, message: '长度至少为 2 个字符', trigger: 'change' },
            ]"
            @add-option="handleAddKeshi"
          />

          <el-form-item
            label="姓名"
            prop="name"
            :rules="[
              { required: true, message: '请输入姓名', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="registerForm.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="性别"
            prop="code"
            :rules="[
              { required: true, message: '请选择性别', trigger: 'blur' },
            ]"
          >
            <el-select v-model="registerForm.sex" placeholder="请选择性别">
              <el-option label="男" value="male"></el-option>
              <el-option label="女" value="female"></el-option>
            </el-select>
          </el-form-item>

          <!-- 自定义验证规则 -->
          <SelectWithAdd
            v-model="registerForm.zhicheng"
            label="职称"
            prop="zhicheng"
            :options="zhichengs"
            placeholder="请选择职称"
            :rules="[
              { required: true, message: '请选择职称', trigger: 'change' },
              { min: 2, message: '长度至少为 2 个字符', trigger: 'change' },
            ]"
            @add-option="handleAddZhicheng"
          />

          <el-form-item
            label="手机号"
            prop="phone"
            :rules="[
              { required: true, message: '请输入手机号', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="registerForm.phone"
              placeholder="请输入手机号"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="密码"
            prop="password"
            :rules="[
              { required: true, message: '请输入密码', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="registerForm.password"
              type="password"
              placeholder="请输入密码"
              show-password
            />
          </el-form-item>

          <el-form-item>
            <div class="flex justify-between w-full">
              <el-button type="primary" @click="submitRegister">注册</el-button>
              <el-button type="primary" @click="toggleForm">登录</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </transition>
  </div>
</template>

<script>
import { registerDoctor, loginDoctor } from "../../api/UserApi"; // 导入网络请求函数
import { useRouter } from "vue-router"; // 导入路由
import axios from "axios"; // 导入 axios
import { mapActions } from "vuex";

import { hospitals } from "./hospitals";
import { keshis } from "./keshis";
import { zhichengs } from "./zhichengs";

import SelectWithAdd from "@/components/selectwithadd";
export default {
  components: {
    SelectWithAdd,
  },
  data() {
    return {
      showLogin: true, // 控制显示登录表单
      loginForm: {
        hospital: "",
        keshi: "",
        role: "",
        name: "",
        password: "",
      },
      registerForm: {
        hospital: "",
        keshi: "",
        name: "",
        zhicheng: "",
        phone: null,
        sex: null,
        password: "",
        role: "转诊医生",
      },
      isPasswordVisible: false, // 控制密码可见性
      hospitals,
      keshis,
      zhichengs,
    };
  },
  setup() {
    const router = useRouter(); // 使用路由

    const goToReferralPatient = (userInfo) => {
      router.replace({ name: "DoctorHome", query: userInfo }); // 传递用户信息
    };

    return { goToReferralPatient };
  },

  methods: {
    ...mapActions(["login", "logout", "setUserInfo"]),
    validateRegisterForm() {
      // 检查每个字段是否已填写
      return (
        this.registerForm.hospital &&
        this.registerForm.keshi &&
        this.registerForm.name &&
        this.registerForm.zhicheng &&
        this.registerForm.phone &&
        this.registerForm.sex &&
        this.registerForm.password
      );
    },

    validateLoginForm() {
      // 检查每个字段是否已填写
      return (
        this.loginForm.hospital &&
        this.loginForm.keshi &&
        this.loginForm.name &&
        this.loginForm.password
      );
    },

    async submitRegister() {
      // 验证表单字段是否完整
      const isFormValid = this.validateRegisterForm();
      if (!isFormValid) {
        this.$message({
          type: "warning",
          message: "请确保所有字段都已填写完整。",
        });
        return;
      }

      try {
        console.log("注册信息:", this.registerForm);
        const result = await registerDoctor(this.registerForm); // 使用 axios 发送请求
        // 存储用户信息到 Vuex
        await this.setUserInfo(this.registerForm);

        // 设置登录状态
        await this.login("true");
        this.$message({
          type: "success",
          message: "注册成功",
        });
        // 跳转到 ReferralPatientForm 页面并传递用户信息
        this.goToReferralPatient(this.registerForm); // 传递注册表单信息
      } catch (error) {
        this.$message({
          type: "error",
          message: error.message || "注册失败，请重试",
        });
      }
    },

    async submitLogin() {
      try {
        // 发送登录请求到后端
        //const response = await axios.post('/api/login', this.loginForm);
        // 验证表单字段是否完整
        const isFormValid = this.validateLoginForm();
        if (!isFormValid) {
          this.$message({
            type: "warning",
            message: "请确保所有字段都已填写完整。",
          });
          return;
        }
        const response = await loginDoctor(this.loginForm); // 使用 axios 发送请求

        console.log("login", response);

        // 假设后端返回的结果中包含用户信息
        if (response.success) {
          //alert("登录成功");
          this.$message({
            type: "success",
            message: "登录成功",
          });
          await this.login("true");
          await this.setUserInfo(response.userInfo); // 将用户信息存入 Vuex
          // 跳转到 ReferralPatientForm 页面并传递用户信息
          this.goToReferralPatient(response.userInfo); // 传递用户信息
        } else {
          alert(response.data.message); // 显示错误信息
        }
      } catch (error) {
        this.$message({
          type: "error",
          message: error.message || "登录失败，请重试",
        });
      }
    },

    toggleForm() {
      this.showLogin = !this.showLogin; // 切换表单
    },

    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible; // 切换密码可见性
    },

    // 自定义验证方法
    validatePathologyReport(rule, value, callback) {
      if (!value) {
        callback(new Error("请选择病理类型"));
      } else if (value.length < 2) {
        callback(new Error("病理类型长度至少为 2 个字符"));
      } else {
        callback();
      }
    },

    handleAddHospital(newOption) {
      const newValue = {
        value: newOption,
        label: newOption,
      };
      this.hospitals.unshift(newValue);
      this.registerForm.hospital = newOption;
    },
    handleAddKeshi(newOption) {
      const newValue = {
        value: newOption,
        label: newOption,
      };
      this.keshis.unshift(newValue);
      this.registerForm.keshi = newOption;
    },
    handleAddZhicheng(newOption) {
      const newValue = {
        value: newOption,
        label: newOption,
      };
      this.zhichengs.unshift(newValue);
      this.registerForm.zhicheng = newOption;
    },

    handleloginAddHospital(newOption) {
      const newValue = {
        value: newOption,
        label: newOption,
      };
      this.hospitals.unshift(newValue);
      this.loginForm.hospital = newOption;
    },
    handleloginAddKeshi(newOption) {
      const newValue = {
        value: newOption,
        label: newOption,
      };
      this.keshis.unshift(newValue);
      this.loginForm.keshi = newOption;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  /* 设置为 100% 以确保填满整个页面 */
  position: relative;
  /* 使子元素可以绝对定位 */
  background-color: #f3ededee;
  background-image: url("@/assets/images/4.jpg"); /* Add your image path */
  background-size: cover; /* Ensure the image covers the entire container */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Prevent image repetition */
  /* 深色背景 */
}

.el-form {
  backdrop-filter: blur(10px);
  /* 毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.146);
  /* 半透明背景 */
  border-radius: 10px;
  /* 圆角 */
  margin: 15px;
  padding: 20px;
  /* 内边距 */
  color: #ffffff !important;
}

.form-wrapper {
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.146);
}

.form-title {
  text-align: center;
  margin: 20px 0;
  font-size: 24px;
  font-weight: 600;
  color: #000 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  /* 动画持续时间 */
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 2.1.8 版本中 */ {
  opacity: 0;
  /* 初始和结束透明度 */
}

.password-container {
  display: flex;
  align-items: center;
}

.password-container input {
  flex: 1;
  /* 使输入框占据剩余空间 */
  margin-right: 10px;
  /* 输入框和按钮之间的间距 */
}
</style>
